import type { IconSvgObject } from './types';

const FileMusicIcon: IconSvgObject = [
  ["path", { d: "M19 12V9L12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2V7C12 8.10457 12.8954 9 14 9H19", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.3971 19.7446C16.3971 20.9885 15.4127 21.9969 14.1985 21.9969C12.9843 21.9969 12 20.9885 12 19.7446C12 18.5007 12.9843 17.4923 14.1985 17.4923C15.4127 17.4923 16.3971 18.5007 16.3971 19.7446ZM16.3971 19.7446V14C16.6172 14.4963 17.7041 16.6999 19.0009 16.6999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileMusicIcon;
